import { createChatBotMessage } from 'react-chatbot-kit';

const config = {
  botName: 'Verifech',
  initialMessages: [createChatBotMessage(`Hello! How can I assist you today?`)],
};

export default config;